









































































    import AbpBase from '@/lib/abpbase'
    import Util from '@/lib/util'
    import PageRequest from '@/store/entities/page-request'
    import { Component } from 'vue-property-decorator'
    import Ajax from '../../lib/ajax'
    import Slider from '@/store/entities/slider'
    class  PageMediaRequest extends PageRequest{
        keyword:string;
    }
    @Component
    export default class Sliders extends AbpBase {
        pagerequest:PageMediaRequest=new PageMediaRequest();
        intervalId:any=null;
        progressVal:number=0;
        progressVis:boolean=false;
        progressStatus:string="active"
        slider:Slider = new Slider();
        editSlider:Slider = new Slider();
        editIndex:number= -1;
        ftpIsActive:boolean = Util.abp.setting.getBoolean("App.FtpIsActive");
        ftpServerMediaPath:string = Util.abp.setting.get('App.ServerMediaPath');
        get list(){
            return this.$store.state.slider.list;
        }
        get loading(){
            return this.$store.state.slider.loading;
        }
        get pageSize(){
            return this.$store.state.slider.pageSize;
        }
        get totalCount(){
            return this.$store.state.slider.totalCount;
        }
        get currentPage(){
            return this.$store.state.slider.currentPage;
        }
        async changeIsActive(status) {
            await this.$store.dispatch({
            type: "options/isFtpActive",
            data: { active: status },
            });
            this.ftpIsActive = status;
            Util.abp.setting.set("App.FtpIsActive",status.toString())
        }
        uploadFile(efile){
            const self = this; 
            this.progressVal = 0;
            this.progressVis = true;
            let formData = new FormData();
            this.intervalId = setInterval( function(){
                self.progress();
            }.bind(this), 800);
            for(let index=0; index<1; index++)
            {
                formData.append('files', efile);
            } 
            formData.append('responsibleUserId', Util.abp.session.userId);
            this.$store.commit('medialist/setLoading',true);
            this.$store.dispatch({
                type: "mediamanager/createSliderItems",
                data: formData
            }).then( ()=> {
                this.$store.commit('medialist/setLoading',false);
                this.getpage();
            }).catch(
                ( err ) => {
                    this.$store.commit('medialist/setLoading',false);
                    this.stopUpdatingProgressIndicator();
                    this.progressVal = 100;
                    this.progressVis = false;
                    this.$Modal.error({title:this.L('Error'),content:this.L('FileUploadError')});
                    console.log("Plik błąd")
                    console.log(err);
                    return false;
            });
            return false;
        }
        pageChange(page:number){
            this.$store.commit('slider/setCurrentPage',page);
            this.getpage();
        }
        pagesizeChange(pagesize:number){
            this.$store.commit('slider/setPageSize',pagesize);
            this.getpage();
        }
        async getpage(){         
            this.pagerequest.maxResultCount=this.pageSize;
            this.pagerequest.skipCount=(this.currentPage-1)*this.pageSize;
            //filters            
            await this.$store.dispatch({
                type:'slider/getAll',
                data:this.pagerequest
            })
        }
        async deleteSlider(row,index){
            await this.$store.dispatch({
                type:'slider/delete',
                data:row
            })
            await this.getpage();
        }
        async up(row,index){
            await this.$store.dispatch({
                type:'slider/up',
                data:row
            }).then( async ()  => {
                await this.getpage();
            })   
        }
        async down(row,index){
            await this.$store.dispatch({
                type:'slider/down',
                data:row
            }).then( async ()  => {
                await this.getpage();
            })   
        }
        async save(index){
            this.list[index].fileWebPath = this.editSlider.fileWebPath;
            this.list[index].order =this.editSlider.order;
            this.list[index].url = this.editSlider.url;
            this.editIndex = -1;
            this.editSlider.id = this.list[index].id;
            this.editSlider.featuredFileId = this.list[index].featuredFileId
            await this.$store.dispatch({
                type:'slider/update',
                data: this.editSlider
            })
        }
        edit(row,index){ 
            let edit = new Slider();
            edit.fileWebPath = row.fileWebPath;
            edit.order = row.order;
            edit.url = row.url;
            this.editSlider = edit;
            this.editIndex = index;
        }
        dwonloadAttachment(url,filename){
            Ajax.get(url, { responseType: 'blob' })
                .then(response => {
                    const blob = new Blob([response.data], { type: 'application/pdf' })
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = filename
                    link.click()
                    URL.revokeObjectURL(link.href)
                }).catch(console.error)
        }

        columns=[
        {            
            title:this.L('File'),
            slot:'fileWebPath',
            wdith:120
            },
            {
                title:this.L('FileName'),
                slot:'fileName',
                wdith:80
            },
                        {
                title:this.L('Description'),
                slot:'description',
                wdith:80
            },
            {
                title:this.L('Order'),
                slot:'order',
                wdith:80
            },
            {
                title:this.L('Link'),
                slot:'url',
                wdith:80
            },
            {
                title: this.L('Action'),
                slot: 'action',
                width: 160
            }
        ]
        async progress(){
            let result = await this.$store.dispatch({
                type: "mediamanager/progress",
            })
            this.progressVal = result;
        }     
		stopUpdatingProgressIndicator() {
			clearInterval(this.intervalId);
		}
        async search(){
            this.$store.commit('slider/setCurrentPage',1);
            this.getpage();
        }
        async created(){
            this.getpage();
        }
    };
